<div class="owner-stmt-rez-list-container">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <p-table #pt [value]="ownerStmtsRez" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerStmtRezId"
    selectionMode="single" [(selection)]="ownerStmtRez" (onRowSelect)="onRowSelect($event)" [loading]="loading"
    [paginator]="showPagination" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

    <ng-template pTemplate="caption">
      <div class="d-block text-end justify-content-between align-items-center">
        @if (!ownerStmtId) {
          <h1 style="float: left;margin: 6px;">Owner Stmt Rez</h1>
        }
        <!-- <h5 *ngIf="ownerStmtId" style="float: left;margin: 6px;">Owner Stmt Rez</h5> -->

        <span>
          <!--clear filters-->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
          }

          <!--add new-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Owner Stmt Rez+</button>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          @if (col.showSort) {
            <th class="text-nowrap" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          } @else {
            <th class="text-nowrap">
              {{col.header}}
            </th>
          }
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
      @if (showFilter) {
        <tr>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
          type="text" (input)="pt.filter($event.target.value, 'ownerStmtRezId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
          type="text" (input)="pt.filter($event.target.value, 'reservationId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-multiSelect dropdownIcon="fa fa-caret-down" appendTo="body" [options]="shortTermRentals"
              optionLabel="propertyCode" optionValue="shortTermRentalId"
              [(ngModel)]="selectedProperties"
              [ngStyle]="{'width':'50px','min-width':'100%'}"
              (onChange)="pt.filter($event.value, 'ownerStmtVO.shortTermRentalId', 'in')">
            </p-multiSelect>
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar appendTo="body" [showButtonBar]="true" [(ngModel)]="ownerStmtStartDate" [ngModelOptions]="{ standalone: true }" [ngStyle]="{'width':'50px','min-width':'100%'}"
              [(ngModel)]="ownerStmtStartDate"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onDateChange($event, 'ownerStmtVO.startDate')">
            </p-calendar>
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar appendTo="body" [showButtonBar]="true" [(ngModel)]="ownerStmtEndDate" [ngModelOptions]="{ standalone: true }" [ngStyle]="{'width':'50px','min-width':'100%'}"
              (ngModelChange)="onDateChange($event, 'ownerStmtVO.endDate')">
            </p-calendar>
          </th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
          type="text" (input)="pt.filter($event.target.value, 'guestName', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar appendTo="body" [(ngModel)]="checkInDate" [ngModelOptions]="{ standalone: true }" [showButtonBar]="true" [ngStyle]="{'width':'50px','min-width':'100%'}"
              (ngModelChange)="onDateChange($event, 'checkInDate')">
            </p-calendar>
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <p-calendar appendTo="body" [(ngModel)]="checkOutDate" [ngModelOptions]="{ standalone: true }" [showButtonBar]="true" [ngStyle]="{'width':'50px','min-width':'100%'}"
              (ngModelChange)="onDateChange($event, 'checkOutDate')">
            </p-calendar>
          </th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
          type="text" (input)="pt.filter($event.target.value, 'numNights', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
          type="text" (input)="pt.filter($event.target.value, 'paidNights', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}">
            <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
            type="text" (input)="pt.filter($event.target.value, 'netRevenue', 'in')"> -->
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
            type="text" (input)="pt.filter($event.target.value, 'netRevenueTax', 'in')"> -->
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
            type="text" (input)="pt.filter($event.target.value, 'mgntFee', 'in')"> -->
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
            type="text" (input)="pt.filter($event.target.value, 'mgntFeeTax', 'in')"> -->
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
            type="text" (input)="pt.filter($event.target.value, 'stmtNightNetRevenue', 'in')"> -->
          </th>
          <th [ngStyle]="{'width': 'auto'}">
            <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
            type="text" (input)="pt.filter($event.target.value, 'stmtNightNetRevenueTax', 'in')"> -->
          </th>
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-ownerStmtRez>
      @if (ownerStmtId && (ownerStmtId == ownerStmtRez.ownerStmtId)) {
        <tr [pSelectableRow]="ownerStmtRez"
          [ngClass]="getReconciliationRowClass(ownerStmtRez)">
          <td>{{ownerStmtRez?.ownerStmtRezId || ''}}</td>
          <td>
            @if (!openingReservation[ownerStmtRez.reservationId]) {
              <span class="link fw-bold blink-text" (click)="openReservation(ownerStmtRez.reservationId,$event)"
              >{{ownerStmtRez.reservationId}}</span>
            }
            @if (openingReservation[ownerStmtRez.reservationId]) {
              <i class="pi pi-spinner pi-spin"></i>
            }
          </td>
          <td>{{ownerStmtRez?.shortTermRentalId ? getPropertyCode(ownerStmtRez.shortTermRentalId) : ''}}</td>
          <td>{{ownerStmtRez?.startDate ? (ownerStmtRez?.startDate | date:'MM/dd/yyyy') : ''}}</td>
          <td>{{ownerStmtRez?.endDate ? (ownerStmtRez?.endDate | date:'MM/dd/yyyy') : ''}}</td>
          <td>{{ownerStmtRez.guestName}}</td>
          <td>{{ownerStmtRez?.checkInDate ? (ownerStmtRez?.checkInDate | date:'MM/dd/yyyy') : ''}}</td>
          <td>{{ownerStmtRez?.checkOutDate ? (ownerStmtRez?.checkOutDate | date:'MM/dd/yyyy') : ''}}</td>
          <td>{{ownerStmtRez?.numNights || 0}}</td>
          <td>{{ownerStmtRez?.paidNights || 0}}</td>
          <td>{{(ownerStmtRez?.netRevenue || 0) | currency }}</td>
          <td>{{(ownerStmtRez?.netRevenueTax || 0) | currency}}</td>
          <td>{{(ownerStmtRez?.mgntFee || 0) | currency}}</td>
          <td>{{(ownerStmtRez?.mgntFeeTax || 0) | currency}}</td>
          <td>{{(ownerStmtRez?.stmtNightNetRevenue || 0) | currency}}</td>
          <td>{{(ownerStmtRez?.stmtNightNetRevenueTax || 0) | currency}}</td>
          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
                style="color:blue; font-size:110%; padding-right:20px;"
              (click)="onOpenFormEdit(ownerStmtRez)"></i>
            </a>
          </span>
        </td>
      </tr>
    }

    @if (!ownerStmtId) {
      <tr [pSelectableRow]="ownerStmtRez"
        [ngClass]="getReconciliationRowClass(ownerStmtRez)">
        <td>{{ownerStmtRez?.ownerStmtRezId || ''}}</td>
        <td>
          @if (!openingReservation[ownerStmtRez.reservationId]) {
            <span class="link fw-bold blink-text" (click)="openReservation(ownerStmtRez.reservationId,$event)"
            >{{ownerStmtRez.reservationId}}</span>
          }
          @if (openingReservation[ownerStmtRez.reservationId]) {
            <i class="pi pi-spinner pi-spin"></i>
          }
        </td>
        <td>{{ownerStmtRez?.shortTermRentalId ? getPropertyCode(ownerStmtRez.shortTermRentalId) : ''}}</td>
        <td>{{ownerStmtRez?.startDate ? (ownerStmtRez?.startDate | date:'MM/dd/yyyy') : ''}}</td>
        <td>{{ownerStmtRez?.endDate ? (ownerStmtRez?.endDate | date:'MM/dd/yyyy') : ''}}</td>
        <td>{{ownerStmtRez?.guestName || ''}}</td>
        <td>{{ownerStmtRez?.checkInDate ? (ownerStmtRez?.checkInDate | date:'MM/dd/yyyy') : ''}}</td>
        <td>{{ownerStmtRez?.checkOutDate ? (ownerStmtRez?.checkOutDate | date:'MM/dd/yyyy') : ''}}</td>
        <td>{{ownerStmtRez?.numNights || 0}}</td>
        <td>{{ownerStmtRez?.paidNights || 0}}</td>
        <td>{{(ownerStmtRez?.netRevenue || 0) | currency }}</td>
        <td>{{(ownerStmtRez?.netRevenueTax || 0) | currency}}</td>
        <td>{{(ownerStmtRez?.mgntFee || 0) | currency}}</td>
        <td>{{(ownerStmtRez?.mgntFeeTax || 0) | currency}}</td>
        <td>{{(ownerStmtRez?.stmtNightNetRevenue || 0) | currency}}</td>
        <td>{{(ownerStmtRez?.stmtNightNetRevenueTax || 0) | currency}}</td>
        <td><span style="float:none">
          <a>
            <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;"
            (click)="onOpenFormEdit(ownerStmtRez)"></i>
          </a>
        </span>
      </td>
    </tr>
  }
</ng-template>
</p-table>
</div>